import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux'

import { getRequest } from '../../helpers/apiHandler';
import config from '../../config/Constant';
import { titleCase } from '../../helpers/helperFunction';
import ListPage from '../ListPage';

const SmsTraffic = () => {
    const { access_token } = useSelector((state) => state.auth.user)
    const [loadingData, setLoadingData] = useState(false);
    const [search, setSearch] = useState('');
    const [data, setData] = useState([]);
    const [searchData, setSearchData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [pollingCount, setPollingCount] = useState(0);
    const [tableKey, setTableKey] = useState(-1);

    const [alertState, setAlertState] = useState({
        show: false,
        variant: 'danger',
        message: '',
    });

    const fetch_data = useCallback(() => {
        setLoadingData(true);
        const requestData = { headers: { Authorization: access_token.token } };
        getRequest(`/admin/sms-traffic`, requestData, (res) => {
            if (res.success) {
                const result = res.data;
                setData(result);
                const filteredData = result.filter((item) =>
                    item.name.toLowerCase().includes(search.toLowerCase()) ||
                    item.email.toLowerCase().includes(search.toLowerCase())
                );
                setSearchData(filteredData);
                generateColumns(result);
            }
            setLoadingData(false);
        });
    }, [access_token.token, search]);

    const generateColumns = (data) => {
        if (data.length > 0) {
            const keys = Object.keys(data[0]);
            const generatedColumns = keys.map((key) => ({
                name: titleCase(key.replace('_', ' ')),
                sortable: true,
                selector: (row) => row[key],
            }));
            setColumns(generatedColumns);
        }
    };

    const onSearch = (evt) => {
        const { value } = evt.target;
        const filteredData = data.filter((item) =>
            item.name.toLowerCase().includes(value.toLowerCase()) ||
            item.email.toLowerCase().includes(value.toLowerCase()),
        );
        setSearch(value);
        setSearchData(value ? filteredData : data);

        // Find the index of the first matching item in the original data array
        const index = data.findIndex((item) =>
            item.name.toLowerCase().includes(value.toLowerCase()) ||
            item.email.toLowerCase().includes(value.toLowerCase()),
        );
        setTableKey(index);
    };

    useEffect(() => {
        fetch_data();

        const intervalId = setInterval(() => {
            setPollingCount((prevCount) => {
                if (prevCount < 100) { // 100 * 5 seconds = 500 seconds
                    fetch_data();
                    return prevCount + 1;
                } else {
                    clearInterval(intervalId);
                    return prevCount;
                }
            });
        }, 5000);

        return () => clearInterval(intervalId);
    }, [fetch_data]);

    useEffect(() => {
        if (alertState.show) {
            setTimeout(() => {
                setAlertState({
                    message: '',
                    show: false,
                    variant: '',
                });
            }, config.notify_time);
        }
    }, [alertState]);

    return (
        <ListPage
          title="SMS Traffic"
          search={search}
          onSearch={onSearch}
          alert={alertState}
          setAlert={setAlertState}
          columns={columns}
          data={search === '' ? data : searchData}
          tableKey={tableKey}
        >
        </ListPage>
    );
};

export default SmsTraffic;
